/* Grihvas cart v4: add to bag in place, bag count always fresh, optimistic steppers, fly-to-bag feedback */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.23,1,.32,1)';
  var CART_SVG = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 4h2l2.2 10.2a1.5 1.5 0 0 0 1.5 1.2h8.6a1.5 1.5 0 0 0 1.5-1.1L21 8H6.2"/><circle cx="9.5" cy="19.5" r="1.3"/><circle cx="17" cy="19.5" r="1.3"/></svg>';
  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>';
  var cart = null;
  var pending = {};
  var J = { Accept: 'application/json' };
  var JH = { Accept: 'application/json', 'Content-Type': 'application/json' };
  function money(c) { return '₹' + (c / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 }); }
  function esc(t) { return String(t || '').replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function tick(el, dir) { if (window.gvTick) window.gvTick(el, dir); }
  function post(url, body) {
    return fetch(root + url, { method: 'POST', headers: JH, credentials: 'same-origin', body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function fetchCart() {
    return fetch(root + 'cart.js', { headers: J, credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  function setCart(c, pop) { cart = c; bubble(c.item_count, pop); sync(); qaSync(); }
  function refresh() { return fetchCart().then(function (c) { setCart(c, false); return c; }).catch(function () {}); }

  /* header bag count + sticky badge. pop only when something was just added */
  function bubble(n, pop) {
    document.querySelectorAll('cart-icon').forEach(function (ci) {
      if (typeof ci.renderCartBubble === 'function') { try { ci.renderCartBubble(n, !!pop && !reduce); } catch (e) {} }
    });
    document.querySelectorAll('[data-gv-cart-count]').forEach(function (e) {
      var txt = n > 99 ? '99+' : String(n);
      if (e.textContent !== txt) { e.textContent = txt; if (pop && !reduce && e.animate) e.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.35)' }, { transform: 'scale(1)' }], { duration: 320, easing: EASE }); }
      e.hidden = !n;
    });
  }

  /* toast */
  var toastEl, toastT;
  function toast(msg, ok) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'gv-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('is-error', ok === false);
    toastEl.innerHTML = '<span>' + esc(msg) + '</span>' + (ok === false ? '' : '<a href="' + root + 'cart">View bag &rarr;</a>');
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }
  function errText(err, fallback) { return (err && (err.description || err.message)) || fallback; }

  /* fly a thumbnail from the button to the bag icon */
  function bagRect() {
    var els = document.querySelectorAll('.gv-sticky__icon, cart-icon');
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (r.width && r.bottom > 0 && r.top < window.innerHeight && getComputedStyle(els[i]).visibility !== 'hidden') return r;
    }
    return null;
  }
  function fly(from, img) {
    if (reduce || !from || !document.body.animate) return Promise.resolve();
    var t = bagRect(); if (!t) return Promise.resolve();
    var f = from.getBoundingClientRect();
    var x0 = f.left + f.width / 2, y0 = f.top + f.height / 2, dx = t.left + t.width / 2 - x0, dy = t.top + t.height / 2 - y0;
    var outer = document.createElement('span'); outer.className = 'gv-fly';
    var inner = document.createElement('span'); inner.className = 'gv-fly__y';
    if (img) inner.style.backgroundImage = 'url("' + img + '")';
    outer.appendChild(inner); document.body.appendChild(outer);
    outer.style.transform = 'translate(' + x0 + 'px,' + y0 + 'px)';
    var D = 560;
    var a = outer.animate([{ transform: 'translate(' + x0 + 'px,' + y0 + 'px)' }, { transform: 'translate(' + (x0 + dx) + 'px,' + y0 + 'px)' }], { duration: D, easing: 'cubic-bezier(.45,0,.55,1)', fill: 'forwards' });
    inner.animate([{ transform: 'translateY(0) scale(1)', opacity: 1 }, { transform: 'translateY(' + dy + 'px) scale(.32)', opacity: .85 }], { duration: D, easing: 'cubic-bezier(.55,-0.45,.75,.95)', fill: 'forwards' });
    return new Promise(function (res) { a.onfinish = function () { outer.remove(); res(); }; setTimeout(function () { if (outer.isConnected) outer.remove(); res(); }, D + 200); });
  }
  function productImg() {
    var im = document.querySelector('.gv-gallery__main img.is-active') || document.querySelector('.gv-gallery__main img');
    return im ? (im.currentSrc || im.src) : '';
  }

  /* button states: '' | loading | done */
  function ensureFaces(btn) {
    if (!btn || btn.querySelector('[data-gv-face]')) return;
    var label = btn.innerHTML;
    btn.innerHTML = '<span class="gv-btn__face" data-gv-face>' + label + '</span><span class="gv-btn__done" aria-hidden="true">' + CHECK_SVG + 'Added to bag</span>';
  }
  function setBtn(btn, s) {
    if (!btn) return;
    if (s) btn.dataset.state = s; else delete btn.dataset.state;
    btn.setAttribute('aria-busy', s === 'loading' ? 'true' : 'false');
  }
  function shake(el) { if (!reduce && el && el.animate) el.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-5px)' }, { transform: 'translateX(4px)' }, { transform: 'translateX(-2px)' }, { transform: 'translateX(0)' }], { duration: 320, easing: 'ease-out' }); }

  function addItems(items, origin, img) {
    return post('cart/add.js', { items: items }).then(function () {
      return Promise.all([fly(origin, img), fetchCart()]);
    }).then(function (res) { setCart(res[1], true); return res[1]; });
  }
  function runAdd(btn, items, origin, img, quiet) {
    if (btn && btn.dataset.state === 'loading') return Promise.resolve();
    ensureFaces(btn);
    setBtn(btn, 'loading');
    var n = items.reduce(function (s, i) { return s + i.quantity; }, 0);
    return addItems(items, origin || btn, img).then(function () {
      setBtn(btn, 'done');
      if (!quiet) toast(n > 1 ? n + ' items added to your bag' : 'Added to your bag');
      setTimeout(function () { setBtn(btn, ''); }, 1500);
    }).catch(function (err) {
      setBtn(btn, '');
      shake(btn);
      toast(errText(err, 'Could not add this item. Please try again.'), false);
    });
  }

  /* 1) every Grihvas product form adds in place */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    if (!f.closest('.gv, gv-product')) return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]');
    var idEl = f.querySelector('[name="id"]:checked') || f.querySelector('[name="id"]');
    var qEl = f.querySelector('[name="quantity"]');
    if (!idEl || (btn && btn.disabled)) return;
    var sticky = document.querySelector('.gv-sticky');
    var quiet = !!sticky && window.innerWidth <= 749;
    runAdd(btn, [{ id: parseInt(idEl.value, 10), quantity: Math.max(1, parseInt(qEl ? qEl.value : 1, 10) || 1) }], btn, productImg(), quiet);
  }, true);

  /* shared: change a line optimistically, send once the taps settle */
  function lineFor(id) { if (!cart || !id) return null; for (var i = 0; i < cart.items.length; i++) { if (cart.items[i].variant_id === id) return cart.items[i]; } return null; }
  function qtyOf(line) { var p = line && pending[line.key]; return p ? p.target : (line ? line.quantity : 0); }
  function step(variantId, delta) {
    var line = lineFor(variantId);
    if (!line) return;
    var p = pending[line.key] || (pending[line.key] = { target: line.quantity, timer: 0 });
    p.target = Math.max(0, p.target + delta);
    paint(variantId, p.target, delta);
    clearTimeout(p.timer);
    p.timer = setTimeout(function () {
      var target = p.target;
      post('cart/change.js', { id: line.key, quantity: target })
        .then(function (c) { if (pending[line.key] === p && p.target === target) delete pending[line.key]; setCart(c, false); })
        .catch(function (err) { delete pending[line.key]; toast(errText(err, 'Could not update the quantity.'), false); refresh(); });
    }, 320);
  }
  function paint(variantId, q, dir) {
    if (bar && currentId() === variantId) {
      if (q === 0) bar.dataset.state = 'add';
      else { var s = bar.querySelector('[data-gv-sticky-q]'); if (s.textContent !== String(q)) { s.textContent = q; tick(s, dir); } }
    }
    document.querySelectorAll('.gv-qa[data-variant="' + variantId + '"]').forEach(function (w) {
      if (q === 0) { w.dataset.state = 'add'; return; }
      var el = w.querySelector('[data-gv-qa-q]');
      if (el && el.textContent !== String(q)) { el.textContent = q; tick(el, dir); }
    });
    if (cart) {
      var total = 0;
      cart.items.forEach(function (it) { total += it.variant_id === variantId ? q : qtyOf(it); });
      bubble(total, false);
    }
  }

  /* 2) mobile sticky bar on the product page */
  var bar, form, mainBtn;
  function currentId() {
    if (!form) return null;
    var el = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
    return el ? parseInt(el.value, 10) : null;
  }
  function faceText(b) { var f = b && b.querySelector('[data-gv-face]'); return f ? f.textContent : (b ? b.textContent : ''); }
  function sync() {
    if (!bar) return;
    var line = lineFor(currentId());
    bar.dataset.state = line && qtyOf(line) > 0 ? 'in' : 'add';
    var add = bar.querySelector('.gv-sticky__add');
    var face = add.querySelector('[data-gv-face]');
    if (mainBtn) {
      var sold = mainBtn.disabled;
      face.textContent = sold ? (mainBtn.dataset.soldout || 'Sold out') : faceText(mainBtn);
      add.disabled = sold;
    }
    if (line) bar.querySelector('[data-gv-sticky-q]').textContent = qtyOf(line);
  }

  /* 4) ADD on product photos (home + category cards) */
  function qaSync() {
    document.querySelectorAll('.gv-qa[data-variant]').forEach(function (w) {
      if (w.dataset.adding) return;
      var line = lineFor(parseInt(w.dataset.variant, 10));
      var q = qtyOf(line);
      w.dataset.state = q > 0 ? 'in' : 'add';
      if (q > 0) { var el = w.querySelector('[data-gv-qa-q]'); if (el) el.textContent = q; }
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-gv-qa-add],[data-gv-qa-d]');
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    var w = t.closest('.gv-qa');
    if (!w) return;
    if (t.hasAttribute('data-gv-qa-d')) { step(parseInt(w.dataset.variant, 10), parseInt(t.getAttribute('data-gv-qa-d'), 10)); return; }
    if (!w.dataset.variant) { openSheet(w.dataset.handle); return; }
    if (w.dataset.adding) return;
    w.dataset.adding = '1';
    w.dataset.state = 'in';
    var el = w.querySelector('[data-gv-qa-q]'); if (el) el.textContent = '1';
    var card = w.closest('product-card, .gv-card, li, article');
    var im = card && card.querySelector('img');
    addItems([{ id: parseInt(w.dataset.variant, 10), quantity: 1 }], t, im ? (im.currentSrc || im.src) : '')
      .then(function () { delete w.dataset.adding; qaSync(); toast('Added to your bag'); })
      .catch(function (err) { delete w.dataset.adding; w.dataset.state = 'add'; shake(w); toast(errText(err, 'Could not add this item. Please try again.'), false); });
  }, true);

  /* pack picker sheet for products with several packs */
  var sheet;
  function closeSheet() {
    if (!sheet || !sheet.open) return;
    sheet.classList.remove('is-open');
    setTimeout(function () { if (sheet.open) sheet.close(); }, 220);
  }
  function openSheet(handle) {
    if (!handle) return;
    if (!sheet) {
      sheet = document.createElement('dialog');
      sheet.className = 'gv-sheet';
      sheet.setAttribute('aria-label', 'Choose a pack');
      document.body.appendChild(sheet);
      sheet.addEventListener('click', function (e) {
        if (e.target === sheet || (e.target.closest && e.target.closest('[data-gv-sheet-close]'))) { closeSheet(); return; }
        var o = e.target.closest && e.target.closest('[data-gv-sheet-v]');
        if (!o || o.disabled) return;
        var cta = o.querySelector('.gv-sheet__cta');
        o.disabled = true;
        cta.textContent = 'Adding';
        addItems([{ id: parseInt(o.getAttribute('data-gv-sheet-v'), 10), quantity: 1 }])
          .then(function () { cta.innerHTML = CHECK_SVG.replace('<svg ', '<svg width="16" height="16" ') + ' Added'; toast('Added to your bag'); setTimeout(closeSheet, 450); })
          .catch(function (err) { toast(errText(err, 'Could not add this pack. Please try again.'), false); o.disabled = false; cta.textContent = 'ADD'; });
      });
      sheet.addEventListener('cancel', function (e) { e.preventDefault(); closeSheet(); });
    }
    sheet.innerHTML = '<div class="gv-sheet__panel"><p class="gv-sheet__loading">Loading packs</p></div>';
    if (!sheet.open) sheet.showModal();
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: J })
      .then(function (r) { if (!r.ok) throw new Error('load'); return r.json(); })
      .then(function (p) {
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
        var h = '<div class="gv-sheet__panel"><div class="gv-sheet__head">' + (img ? '<img src="' + img + '" alt="" width="64" height="64">' : '') +
          '<div class="gv-sheet__meta"><p class="gv-sheet__title">' + esc(p.title) + '</p><p class="gv-sheet__sub">Choose a pack</p></div>' +
          '<button type="button" class="gv-sheet__x" data-gv-sheet-close aria-label="Close">&times;</button></div><ul class="gv-sheet__list">';
        p.variants.forEach(function (v) {
          var off = v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s><span class="gv-sheet__off">-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%</span>' : '';
          h += '<li><button type="button" class="gv-sheet__opt" data-gv-sheet-v="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
            '<span class="gv-sheet__name">' + esc(v.title) + '</span>' +
            '<span class="gv-sheet__price"><b>' + money(v.price) + '</b>' + off + '</span>' +
            '<span class="gv-sheet__cta">' + (v.available ? 'ADD' : 'Sold out') + '</span></button></li>';
        });
        h += '</ul><a class="gv-sheet__more" href="' + p.url + '">See full details &rarr;</a></div>';
        sheet.innerHTML = h;
        var first = sheet.querySelector('.gv-sheet__opt:not([disabled])');
        if (first) first.focus();
      })
      .catch(function () { sheet.innerHTML = '<div class="gv-sheet__panel"><p class="gv-sheet__loading">Could not load packs. <a href="' + root + 'products/' + encodeURIComponent(handle) + '">Open the product</a></p></div>'; });
  }

  function buildBar() {
    form = document.getElementById('GvProductForm');
    if (!form || document.querySelector('.gv-sticky')) return;
    mainBtn = form.querySelector('[data-gv-add]');
    ensureFaces(mainBtn);
    bar = document.createElement('div');
    bar.className = 'gv-sticky';
    bar.dataset.state = 'add';
    bar.innerHTML =
      '<button type="button" class="gv-btn gv-sticky__add"><span class="gv-btn__face" data-gv-face>Add to bag</span><span class="gv-btn__done" aria-hidden="true">' + CHECK_SVG + 'Added to bag</span></button>' +
      '<a class="gv-sticky__view" href="' + root + 'cart"><span class="gv-sticky__icon">' + CART_SVG + '<span class="gv-sticky__badge" data-gv-cart-count hidden></span></span>View bag</a>' +
      '<div class="gv-sticky__qty" role="group" aria-label="Quantity in bag"><button type="button" data-d="-1" aria-label="Remove one">&minus;</button><span data-gv-sticky-q aria-live="polite">1</span><button type="button" data-d="1" aria-label="Add one more">+</button></div>';
    document.body.appendChild(bar);
    document.documentElement.classList.add('gv-has-sticky');
    var add = bar.querySelector('.gv-sticky__add');
    add.addEventListener('click', function () {
      var id = currentId();
      if (!id || add.disabled) return;
      var qEl = form.querySelector('[name="quantity"]');
      runAdd(add, [{ id: id, quantity: Math.max(1, parseInt(qEl ? qEl.value : 1, 10) || 1) }], add, productImg(), true).then(sync);
    });
    bar.querySelectorAll('[data-d]').forEach(function (b) { b.addEventListener('click', function () { step(currentId(), parseInt(b.dataset.d, 10)); }); });
    form.addEventListener('change', function () { setTimeout(sync, 0); });
    document.addEventListener('gv:product-change', sync);
  }

  /* 3) Frequently bought together also adds in place */
  customElements.whenDefined('gv-fbt').then(function () {
    var C = customElements.get('gv-fbt');
    C.prototype.add = function () {
      var self = this;
      var items = this.boxes.filter(function (b) { return b.checked; }).map(function (b) { return { id: parseInt(b.dataset.id, 10), quantity: 1 }; });
      if (!items.length) return;
      this.btn.disabled = true;
      addItems(items, this.btn).then(function () { toast(items.length + (items.length > 1 ? ' items' : ' item') + ' added to your bag'); })
        .catch(function (err) { toast(errText(err, 'Could not add. Please try again.'), false); })
        .then(function () { self.btn.disabled = false; });
    };
  });

  /* keep the bag count right on every page: first load, back/forward cache, prerendered pages, tab switches */
  function init() { buildBar(); refresh(); }
  if (document.prerendering) document.addEventListener('prerenderingchange', function () { init(); }, { once: true });
  else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible' && cart) refresh(); });
})();